import React from 'react';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import Select from 'components/Form/Select2';
import { BarsArrowDownIcon } from '@heroicons/react/20/solid';
import { PrintView } from '../../Print/types';
import { GroupCol, GroupRow } from '../../types';
import { TFunction } from 'i18next';
import { getView } from '../../utils/getView';
import { getAllowedColRowGroups } from '../../utils/getAllowedColRowGroups';
import { PrintConfig } from 'containers/Programmations/ProgV2/Preview/types';

function PrintViewOption({
  firstLabel,
  secondLabel,
}: {
  firstLabel: string;
  secondLabel: string;
}) {
  return (
    <div tw="flex">
      <span tw="basis-24 whitespace-nowrap">
        <BarsArrowDownIcon tw="w-4 h-4 inline-block -rotate-90" />
        {firstLabel}
      </span>
      <span tw="whitespace-nowrap">
        <BarsArrowDownIcon tw="w-4 h-4 inline-block -scale-x-100" />
        {secondLabel}
      </span>
    </div>
  );
}

function buildOption(
  groupCol: GroupCol,
  groupRow: GroupRow,
  t: TFunction<['common', 'programmation']>,
) {
  return {
    value: getView({
      groupCol,
      groupRow,
    }),
    label: (
      <PrintViewOption
        firstLabel={t(`programmation:${groupCol}`)}
        secondLabel={t(`programmation:${groupRow}`)}
      />
    ),
  };
}

interface Props {
  mode: 'classic' | 'unified';
  isProgression: boolean;
  printConfig: PrintConfig;
  onUpdatePrintConfig: (v: PrintConfig) => void;
}

export function SelectPrintView({
  mode,
  isProgression,
  onUpdatePrintConfig,
  printConfig,
}: Props) {
  const { t } = useTranslation(['common', 'programmation']);

  const additionalOption = isProgression
    ? [buildOption('periodes', 'semaines', t)]
    : [];

  return (
    <Select<PrintView>
      label={t('programmation:display')}
      onChange={value => onUpdatePrintConfig({ ...printConfig, view: value })}
      value={printConfig.view}
      options={[
        ...getAllowedColRowGroups(mode, isProgression).map(g =>
          buildOption(g.groupCol, g.groupRow, t),
        ),
        ...additionalOption,
      ]}
    />
  );
}
